<template>
  <div class="d-flex align-items-center" @click="select">
    <div class="flex-grow-1 d-flex flex-column">
      <div>{{ name }}</div>
    </div>
    <div class="flex-shrink-0">
      <el-popover
          placement="top-end"
          width="300"
          trigger="click"
      >
        <div class="word-break-normal">{{ description }}</div>
        <button slot="reference" class="btn btn-secondary btn-sm" @click="clickInfo">
          <i class="fas fa-info fa-fw"></i>
        </button>
      </el-popover>
      <button class="btn btn-sm" :class="{'btn-secondary': !isBound, 'btn-danger': isBound}" @click="toggle">
        <i class="fas fa-link fa-fw"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {string}
     */
    name() {
      return _.get(this.row, 'model.name');
    },

    /**
     * @return {string}
     */
    description() {
      return _.get(this.row, 'model.description', 'Empty');
    },

    /**
     * @return {boolean}
     */
    isBound() {
      return Boolean(_.get(this.row, 'is_bound'));
    },
  },

  methods: {
    clickInfo(e) {
      e.preventSelect = true;
    },

    /**
     * @emits select
     */
    select(e) {
      const ignore = _.get(e, 'preventSelect', false);
      if (!ignore) {
        this.$emit('select', this.row);
      }
    },

    /**
     * @emits toggle
     */
    toggle(e) {
      this.$emit('toggle', {url: this.row.toggle_url, id:this.row.model.id});
      e.preventSelect = true;
    },
  },
}
</script>
